<p>child works!</p>
<span>We got : </span><b>{{data}}</b>